import type { Address, Hex } from 'viem';
import type { Maybe } from '@soundxyz/utils';
import { getMerkleProof } from '@utils/merkle';

export function releaseListeningPartyMerkleQueryKey({
  merkleTreeRoot,
  userAddress,
}: {
  merkleTreeRoot: Maybe<Hex>;
  userAddress: Maybe<Address>;
}) {
  return ['release-listening-party-merkle-access', merkleTreeRoot, userAddress] as const;
}

export async function releaseListeningPartyMerkleQueryFn({
  merkleTreeRoot,
  userAddress,
}: {
  merkleTreeRoot: Maybe<Hex>;
  userAddress: Maybe<Address>;
}) {
  if (!merkleTreeRoot || !userAddress) return null;

  const proof = await getMerkleProof({
    merkleRoot: merkleTreeRoot,
    userAddress,
  });

  if (!proof?.length) return false;

  return true;
}
